export function trackTrialSignupClick() {
  if (typeof window === "undefined") return;

  if (typeof window.oaiq !== "function") {
    console.warn("OpenAI Pixel is not loaded.");
    return;
  }

  window.oaiq(
    "measure",
    "custom",
    {
      type: "custom",
    },
    {
      custom_event_name: "trial_signup_click",
    }
  );
}